var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "prodinfo--card" },
        [
          _c("z-search", {
            ref: "search",
            attrs: { configs: _vm.configs },
            on: { "do-query": _vm.query },
            model: {
              value: _vm.searchData,
              callback: function ($$v) {
                _vm.searchData = $$v
              },
              expression: "searchData",
            },
          }),
        ],
        1
      ),
      _c(
        "el-card",
        { staticStyle: { "margin-top": "10px" } },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "auth",
                  rawName: "v-auth",
                  value: "storage::in-stock::export",
                  expression: "'storage::in-stock::export'",
                },
              ],
              staticClass: "mb-16",
              attrs: { loading: _vm.exportLoading },
              on: { click: _vm.exportOrder },
            },
            [_vm._v(" " + _vm._s(_vm.$t("storage::in-stock::export")) + " ")]
          ),
          _c("z-table", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "prodinfo--table",
            attrs: {
              columns: _vm.tableColumns,
              data: _vm.tableData,
              "max-height": 500,
              pagination: _vm.pagination,
            },
            on: {
              "update:pagination": function ($event) {
                _vm.pagination = $event
              },
              "page-change": _vm.handlePageChange,
            },
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      { staticClass: "prodinfo--table__imgTd" },
                      [
                        _c(
                          "el-popover",
                          {
                            attrs: { placement: "top-start", trigger: "hover" },
                          },
                          [
                            _c("ZImg", {
                              staticStyle: { width: "250px", height: "250px" },
                              attrs: { src: row.img },
                            }),
                            _c("ZImg", {
                              staticStyle: {
                                width: "50px",
                                height: "50px",
                                "margin-right": "10px",
                              },
                              attrs: { slot: "reference", src: row.img },
                              slot: "reference",
                            }),
                          ],
                          1
                        ),
                        _c("div", [
                          _c("div", [_vm._v(_vm._s(row.title))]),
                          _c("div", [
                            _vm._v(_vm._s(_vm.$dataCheck(row.categoryName))),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "skuId",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(row.skuId) +
                          _vm._s(row.skuProperty ? "-" + row.skuProperty : "")
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }